var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass:
        "d-flex align-items-center text-center pa-4 mt-4 sticky-card",
      style: { top: _vm.stickyTop, width: _vm.cardWidth },
    },
    [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-avatar",
                {
                  staticClass: "mx-auto avatar-profile",
                  attrs: { size: "140", tile: "" },
                  on: { click: _vm.triggerFileInput },
                },
                [
                  !_vm.selectedImage && !_vm.legajo.photo_url
                    ? _c(
                        "v-icon",
                        { attrs: { color: "grey lighten-1", size: "60" } },
                        [_vm._v("mdi-account")]
                      )
                    : _c("v-img", {
                        attrs: {
                          src: _vm.selectedImage || _vm.legajo.photo_url,
                          alt: "Foto de perfil",
                        },
                      }),
                ],
                1
              ),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: ".png, .jpg, .jpeg" },
                on: { change: _vm.onFileSelected },
              }),
              _vm.legajo.photo_url == null
                ? _c(
                    "p",
                    { staticClass: "text-caption grey--text mt-2 mb-0" },
                    [_vm._v(" Seleccione una foto de perfil ")]
                  )
                : _vm._e(),
              _vm.legajo.id > 0
                ? _c("div", { staticClass: "font-weight-bold text-h6 mt-3" }, [
                    _vm._v(_vm._s(_vm.name_legajo)),
                  ])
                : _vm._e(),
              _vm.legajo.id > 0
                ? _c("div", { staticClass: "grey--text" }, [
                    _vm._v("Legajo: " + _vm._s(_vm.legajo.id)),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }